import dcmjs from 'dcmjs';
import { makeArrayLike } from '../metadataProvider/makeArrayLike';
import { dictionaryLookup, mapTagInfo, parseVm } from '../Tags';
const { DicomMetadataListener } = dcmjs.utilities;
function resolveSingleVm(tagData, dictEntry, tagInfo) {
    if (tagData && tagData.vm !== undefined && tagData.vm !== null) {
        return tagData.vm === 1;
    }
    const vm = tagInfo?.vm ?? dictEntry?.vm;
    if (vm !== undefined && vm !== null) {
        const parsed = parseVm(vm);
        if (parsed !== null) {
            return parsed === 1;
        }
    }
    return null;
}
function isBulkDataValue(val) {
    if (!Array.isArray(val) || val.length === 0) {
        return false;
    }
    const first = val[0];
    if (first instanceof ArrayBuffer || ArrayBuffer.isView(first)) {
        return true;
    }
    if (Array.isArray(first)) {
        return val.every((item) => Array.isArray(item) &&
            item.every((f) => f instanceof ArrayBuffer || ArrayBuffer.isView(f)));
    }
    return false;
}
const DEFAULT_NAME_KEY = 'name';
export class NaturalTagListener {
    constructor(_options) {
    }
    static createMetadataListener(options) {
        return new DicomMetadataListener({}, new NaturalTagListener(options));
    }
    addTag(next, tag, tagInfo) {
        const tagData = mapTagInfo.get(tag);
        const dictEntry = !tagData ? dictionaryLookup(tag) : undefined;
        const name = tagInfo?.name || tagData?.[DEFAULT_NAME_KEY] || dictEntry?.name || tag;
        const singleVm = resolveSingleVm(tagData, dictEntry, tagInfo);
        next(tag, tagInfo);
        this.current.natural = {
            name,
            singleVm,
            tag,
        };
    }
    pop(next) {
        const listener = this;
        const nat = listener.current?.natural;
        const parentContext = listener.current?.parent;
        if (!nat || !parentContext?.dest) {
            return next();
        }
        const result = next();
        const parent = parentContext;
        const raw = parent.dest[nat.tag];
        if (raw === undefined) {
            return result;
        }
        let val = raw.Value ?? raw;
        if (Array.isArray(val) && val.length === 1 && val[0] === undefined) {
            val = [];
        }
        if (isBulkDataValue(val)) {
            parent.dest[nat.name] = val;
            if (nat.name !== nat.tag)
                delete parent.dest[nat.tag];
            return result;
        }
        if (nat.singleVm === true && Array.isArray(val) && val.length === 1) {
            const one = val[0];
            if (typeof one === 'object' &&
                one !== null &&
                !(one instanceof ArrayBuffer) &&
                !ArrayBuffer.isView(one)) {
                parent.dest[nat.name] = makeArrayLike(one);
            }
            else {
                parent.dest[nat.name] = one;
            }
            if (nat.name !== nat.tag)
                delete parent.dest[nat.tag];
            return result;
        }
        if (nat.singleVm === null &&
            Array.isArray(val) &&
            val.length === 1 &&
            typeof val[0] === 'object' &&
            val[0] !== null &&
            !(val[0] instanceof ArrayBuffer) &&
            !ArrayBuffer.isView(val[0])) {
            parent.dest[nat.name] = makeArrayLike(val[0]);
        }
        else {
            parent.dest[nat.name] = val;
        }
        if (nat.name !== nat.tag) {
            delete parent.dest[nat.tag];
        }
        return result;
    }
}
